import React, { useEffect, useMemo, useState } from 'react';
import '../scss/button.scss';
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { ReactComponent as SelfieImg } from '../images/selfie.svg'
import { ReactComponent as ShieldIcon } from '../images/shield.svg'
import { ReactComponent as WarningIcon } from '../images/warning-icon.svg'
import { ReactComponent as CheckGreenIcon } from '../images/check-green-bg.svg'
import PageHeader from '../components/PageHeader';
import { useGetSelfieUrlMutation } from '../lib/services/personalDetailsApi';
import { generateChecksum } from '../lib/middleware/generateChecksum';
import { useLocation, useNavigate } from 'react-router-dom';
import { setPageError } from '../lib/features/personalDetailsSlice';
import { useDispatch, useSelector } from 'react-redux';
import CenteredPopup from '../components/popups/CenteredPopup';
//import { setStartCapture } from '../lib/features/personalDetailsSlice';
import { useTapClickMutation } from '../lib/middleware/TapClickApi';
import { pushCleverTapEvent } from "../lib/middleware/CtEvents";

function TakeSelfie() {
    //const startCapture = useSelector((state) => state.personalDetails.startCapture)
    const [getSelfieUrl, { isLoading }] = useGetSelfieUrlMutation();
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const { pageerror } = useSelector((state) => state.personalDetails)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showMsg, setShowMsg] = useState(true);
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])
    const [tapClick] = useTapClickMutation()

    const handleOpen = () => {
        setIsModalOpen(true);
    }
    const handleClose = () => {
        setIsModalOpen(false);
        dispatch(setPageError(''))
    }
    const modalButtons = [
        { label: 'Close', onClick: handleClose }
    ]
    const hanldeSelfieUrl = async () => {
        try {
            const bodyData = { mode: 'get_profile_pic_upload_url' }
            const checksum = generateChecksum(bodyData)
            let jwt_token
            if (jwt) {
                jwt_token = jwt
                localStorage.setItem('jwt', jwt)
            } else {
                jwt_token = localStorage.getItem('jwt')
            }
            const scrt = secret ? secret : localStorage.getItem('secret')
            const response = await getSelfieUrl({ checksum, jwt_token, scrt }).unwrap()
            if (response && response.status === 'success') {
                //localStorage.setItem("lastVisitedPage", '/personal-details')
                const event_name = 'web_selfie_capture'
                const event_property = {Source: window.localStorage.getItem('utm_source'), Segment: localStorage.getItem('customerSegment')}
                await pushCleverTapEvent({event_name, event_property})
                window.location.href = response.profile_pic_upload_url
            } else if (response && response.status === 'error') {
                if (response.message === 'Login expired! Please re-login.') {
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    const phone = localStorage.getItem('phone')
                    localStorage.clear()
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                } else {
                    dispatch(setPageError(response.message || response.error))
                    handleOpen()
                }
            } else if (response.data && response.data.message === 'Login expired! Please re-login.') {
                handleOpen()
                dispatch(setPageError(response.data.message))
                localStorage.removeItem('jwt');
                localStorage.removeItem('lastVisitedPage');
                const phone = localStorage.getItem('phone')
                localStorage.clear()
                phone ? navigate(`/?phone=${phone}`) : navigate('/');
            } else if (response.error) {
                dispatch(setPageError('Please check your internet or try again later.'))
                handleOpen()
            }
        } catch (error) {
            dispatch(setPageError('Something went wrong. Please try again later.'));
            handleOpen()
        }
    }
    useEffect(() => {
        if (showMsg) {
          setTimeout(() => {
            setShowMsg(false)
          }, 3000);
        }
      }, [showMsg])
    return (
        <div className='external-wrapper selfie-page'>
            <CenteredPopup
                isOpen={isModalOpen}
                buttons={modalButtons}
                onClose={handleClose} icon={<WarningIcon />}>
                <p>{pageerror}</p>
            </CenteredPopup>
            <div className='page-content pb-0'>
                <PageHeader />
                {showMsg && <div className="success-tag"><CheckGreenIcon /> Bank verified successfully</div>}
                <div className='page-heading'>
                    <h2 className='page-title'>Take a Selfie</h2>
                    <ul>
                        <li>Good lighting on your face</li>
                        <li>Hold the phone in front of you</li>
                        <li>Capture in front of a plain background</li>
                    </ul>
                </div>
                <div className='verify-content text-center'>
                    <SelfieImg className='bank-image' />
                    <ul className='selfie-guideline'>
                        <li>
                            <h3>Good lighting</h3>
                            <p>Make sure you are in well lit area and both ears are uncovered</p></li>
                        <li>
                            <h3>Look straight</h3>
                            <p>Hold your phone at eye level and look straight to the camera</p>
                        </li>
                    </ul>
                    <p><ShieldIcon /> Powered by Hyperverge</p>
                </div>
            </div>
            <div className='bottom-footer'>
                <p className='powered-by'>Powered by <StarfinLogo /></p>
                <button type="button" className={`btn btn-primary ${isLoading ? 'disabled' : ''}`} onClick={() => {
                    //dispatch(setStartCapture(true))
                    hanldeSelfieUrl()
                }}>Proceed to Capture</button>
            </div>
        </div>
    );
}

export default TakeSelfie;
